import React from 'react';
import { Box } from 'vindi-ds-components';
import styles from './styles';

function Footer({ children }) {
  return <Box css={styles.optionalLink}>{children}</Box>;
}

export default Footer;
